import { render, staticRenderFns } from "./TrustPilotWidget.vue?vue&type=template&id=1aea9630&lang=pug"
import script from "./TrustPilotWidget.vue?vue&type=script&lang=ts"
export * from "./TrustPilotWidget.vue?vue&type=script&lang=ts"
import style0 from "./TrustPilotWidget.vue?vue&type=style&index=0&id=1aea9630&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports